import { dataHooks } from '@wix/data-hooks';

export const articleVoteButtonDataHooks = dataHooks<{
  featureRequestVoteButton;
  knownIssueVoteButton;
}>('articleVoteButton');
